const AttributeValue = ({attribute, colors, value, onChangeProductAttribute, priceOptionIndex}) => {

    const getType = () => {
        switch (attribute.type_name) {
            case 'LIST':
                return (
                    <select className="form-control"
                            onChange={(e) =>
                                onChangeProductAttribute(attribute.id, {val: e.target.value}, priceOptionIndex)}
                            value={value} style={selectStyling} {...commonAttributes}>
                        <option value="">انتخاب گزینه</option>
                        {attribute.options.map((option) => (
                            <option value={option.id}>{option.value}</option>
                        ))}
                    </select>
                );
            case 'TEXT':
                return <input type="text"
                              onChange={(e) =>
                                  onChangeProductAttribute(attribute.id, {val: e.target.value})}
                              value={value} className="form-control" {...commonAttributes}/>;
            case 'COLOR':
                return (
                    <select className="form-control"
                            onChange={(e) =>
                                onChangeProductAttribute(attribute.id, {val: e.target.value}, priceOptionIndex)}
                            value={value} style={selectStyling} {...commonAttributes}>
                        <option value="">انتخاب رنگ</option>
                        {colors.map((color) => (
                            <option value={color.id}>{color.name}</option>
                        ))}
                    </select>
                );
        }
    }

    return (
        <>
            {getType()}
        </>
    )
}
const commonAttributes = {
    required: 'true',
}
const selectStyling = {
    width: '253px'
}

export default AttributeValue;
